import { useParams } from 'react-router-dom';
import keys from './keys';
import useApiQuery from '../useApiQuery';

const refetchShow = (show) => {
  if (!show || typeof show !== 'object') {
    return false;
  }
  const isImportingShow = show.status === 'processing' && !!show.source;
  return isImportingShow ? 5000 : false;
};

const useGetShow = ({
  showId: showIdParam,
  networkId: networkIdParam,
  disabled = false,
  importRefresh = false,
} = {}) => {
  const { showId: currentShowId, networkId: currentNetworkId } = useParams();
  const showId = showIdParam || currentShowId;
  const networkId = networkIdParam || currentNetworkId;

  const query = useApiQuery({
    requestUrl: networkId ? `/shows/${showId}?networkId=${networkId}` : `/shows/${showId}`,
    disabled: !showId || disabled,
    queryKey: keys(showId, networkId).show,
    refetchInterval: importRefresh ? refetchShow : null,
    refetchOnMount: importRefresh ? refetchShow : null,
  });

  return {
    show: query.data,
    isRedirectedOut: Boolean(query.data?.redirect && query.data?.redirectUrl),
    showError: query.error,
    isShowFetchError: query.isError,
    isShowFetchSuccess: query.isSuccess,
    isShowFetching: query.isFetching,
    isShowLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetShow;
